import { HeroMetricsPanel } from "@/components/HeroMetricsPanel";
import { HeroRackPanel } from "@/components/HeroRackPanel";
import { InlineChatLink } from "@/components/InlineChatLink";

export default function InfrastructureOverview() {
  return (
    <section id="infrastructure-overview" data-testid="infrastructure-overview-section" aria-labelledby="infrastructure-overview-title" className="relative border-b hairline bg-white py-8 md:py-12 scroll-mt-20">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <h2 id="infrastructure-overview-title" data-testid="infrastructure-section-label" className="font-mono-label text-[11px] !tracking-normal text-[#5F6168] mb-6">/ Infrastructure overview</h2>
        <div data-testid="hero-data-safe-area" data-chat-safe-area="wide">
          <div data-testid="hero-overview-row" className="grid grid-cols-1 lg:grid-cols-[minmax(0,7fr)_minmax(0,5fr)] items-stretch gap-5 lg:gap-6">
            <HeroMetricsPanel />
            <HeroRackPanel />
          </div>
          <div className="flex justify-center"><InlineChatLink testId="infrastructure-chat-button" visibilityClassName="min-[1920px]:hidden" /></div>
        </div>
      </div>
    </section>
  );
}